import { useDispatch, useSelector } from 'react-redux';
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Divider, makeStyles } from '@material-ui/core';
import axios from 'axios';
import React, { useCallback, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import ROUTES_NAME from '../../consts/routes-name';
import { FIELDS, LABELS, OPUS_ERROR_ENUM } from '../../consts/text/acesso-pj';
import { VINCULO_PJ_URL } from '../../pages/opin/const';
import { AutenticationActions } from '../../store/ducks/autentication';
import { Yup, masks } from '../../utils';
import CustomButton from '../CustomButton/CustomButton';
import CustomInputForm from '../CustomInputForm/CustomInputForm';
import CustomModal from '../CustomModal/CustomModal';



const useStyles = makeStyles(() => ({
    button: {
        width: '100%',
    },
}));

const formSchema = Yup.object().shape({
    [FIELDS.CPF]: Yup.string().cpf().required(),
});

function ModalFormAcessoPJ({ setError, isOpen = true, setIsOpen }) {
    const styles = useStyles();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { dadosCliente } = useSelector((state) => state.autenticacao);
    const { register, handleSubmit, errors, setValue } = useForm({
        resolver: yupResolver(formSchema),
    });
    const [isLoading, setLoading] = useState(false);

    const onSubmit = useCallback(
        async (value) => {
            try {
                const { cpf } = value;

                setLoading(true);

                const unmaskedCpf = cpf.replace(/\.|-/g, '');

                const { data } = await axios.post(
                    VINCULO_PJ_URL,
                    {
                        cnpjEmpresa: dadosCliente.cpfCnpj,
                        cpfAutorizado: unmaskedCpf,
                    },
                    {
                        headers: {
                            Authorization: `${localStorage.getItem(
                                'tokenBBAuth',
                            )}`,
                        },
                    },
                );

                if (data?.dado?.atributos?.inVinculoValido) {
                    setLoading(false);

                    dispatch(
                        AutenticationActions.setDadosCliente({
                            ...dadosCliente,
                            cpf: unmaskedCpf,
                            cpfValido: true,
                        }),
                    );

                    return;
                }

                throw new Error('Erro na validação do vinculo cpf/cnpj');
            } catch (_) {
                setLoading(false);

                setError({ errorType: OPUS_ERROR_ENUM.CPF_MISMATCH });
                setIsOpen(false);
            }
        },
        [dadosCliente, setError, dispatch, setIsOpen],
    );

    const handleSair = useCallback(() => {
        setIsOpen(false);
        dispatch(AutenticationActions.setDadosCliente(null));

        navigate(ROUTES_NAME.HOME);
    }, [dispatch, setIsOpen, navigate]);

    return (
        <CustomModal
                open={isOpen}
                title={LABELS.HEADER}
                modalWidth={{ sm: 4 }}
                body={
                    <>
                        <Box marginTop={2} />
                        <Divider />

                        <Box paddingX={2} marginBottom={2}>
                            <Box
                                marginTop={6}
                                marginBottom={6}
                                textAlign="center"
                            >
                                {LABELS.DESCRICAO}
                            </Box>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <CustomInputForm
                                    label={LABELS.CPF}
                                    name={FIELDS.CPF}
                                    errors={errors}
                                    inputRef={register}
                                    setValueForm={setValue}
                                    inputProps={{
                                        mask: masks.cpfMask,
                                        showMask: false,
                                        inputMode: 'numeric',
                                    }}
                                />
                                <Box display="flex" justifyContent="center">
                                    <Box marginRight={2} width="100%">
                                        <CustomButton
                                            content={LABELS.BTN_SAIR}
                                            variant="outlined"
                                            className={styles.button}
                                            onClickCallBack={handleSair}
                                            disabled={isLoading}
                                        />
                                    </Box>
                                    <Box width="100%">
                                        <CustomButton
                                            content={LABELS.BTN_SUBMIT}
                                            className={styles.button}
                                            type="submit"
                                        />
                                    </Box>
                                </Box>
                            </form>
                        </Box>
                    </>
                }
            />
    );
}

export default ModalFormAcessoPJ;
